import axios from 'axios'
import config from '../../config/config'

const apiBasePath = config["borderex-api"]


export default {
    GET: (urlPath, params = {}) => {
        return axios.get(`${apiBasePath}/${urlPath}`, {params})
    },
    POST: (urlPath, json = {}) => {
        return axios.post(`${apiBasePath}/${urlPath}`, json)
    },
    PUT: (urlPath, json = {}) => {
        return axios.put(`${apiBasePath}/${urlPath}`, json)
    },
    PATCH: (urlPath, json = {}) => axios.patch(`${apiBasePath}/${urlPath}`, json),
    ALL: (requestArray = []) => axios.all(requestArray),
}
